// 花名册信息
import http from "@/promise/http";
const CONTROLLER_NAME = "/roster/";

// 查询列表
export const postListPage = (pageNum, numPerPage, params) => {
  return http.post(CONTROLLER_NAME.concat("listPage"), {
    pageNum: pageNum,
    numPerPage: numPerPage,
    condition: params,
  });
};

// 查询详情
export const postDetail = (id) => {
  return http.post(CONTROLLER_NAME.concat("detail"), id);
};

// 修改人员名单
export const postSubmitForm = (infoForm) => {
  return http.post(CONTROLLER_NAME.concat("update"), infoForm);
};

// 删除
export const postRemove = (ids) => {
  return http.post(CONTROLLER_NAME.concat("remove"), ids);
};

// 进出场
export const postEntryOrExit = (params) => {
  return http.post(CONTROLLER_NAME.concat("entryOrExit"), params);
};
// 下发人员名单
export const postDistributionTemplate = (params) => {
  return http.post(CONTROLLER_NAME.concat("distributionTemplate"), params);
};

// 签订合同
export const postSignContract = (params) => {
  return http.post(CONTROLLER_NAME.concat("signContract"), params);
};

// 根据图片获取人员信息
export const getWokerInfo = (params) => {
  return http.post(CONTROLLER_NAME.concat("getWokerInfo"), params);
};
